import React, { Component } from "react";
import { ReactComponent as IconTasks } from "../../resources/image/ic_tasks.svg";

class Adapter extends Component {
  state = {
  };

  render() {
    const { tasks , title} = this.props;

    var categories = []

    if (tasks !== undefined && tasks !== null) {
      for (var i = 0; i < tasks.length; i++) {
        var task = tasks[i]
        var team = task.team
        var exists = false
        var index = undefined
        for (var j = 0; j < categories.length; j++) {
          if (categories[j].team === team) {
            exists = true
            index = j
          }
        }

        if (!exists) {
          var category = { team: team, tasks: [task] }
          categories.push(category)
        } else {
          categories[index].tasks.push(tasks[i])
        }
      }
    }

    return (

      <div style={{textAlign: "right"}} >

        <div style={{ color: "dimgrey", fontSize: 13, textAlign: "right" , marginBottom: 10}}>
          <IconTasks
            className="p-0"
            width="25"
            height="25"
          />
          <span style={{ fontSize: 13, color: "dimgrey", marginRight: 6 }}>{title}</span>

        </div>


        {categories.map((category) => (
          <div
          className="mb-2"
           key={category.team}>
            <span style={{fontSize: 15, color: "midnightblue"}}>{category.team}</span>
            <div >
              {category.tasks.map((task) => (
                <div key={task.code}>
                   <span style={{fontSize: 14, color: "brown"}}>{task.code}</span>
                   <span style={{fontSize: 13, color: "black", marginRight: 10}}>{task.title}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default Adapter;
